const l={full:"w-full !max-w-[102px]",small:"!min-w-[85px]"},x="div";export{x as SearchTrendsCardDefaultDefaultAsType,l as SearchTrendsCardSizes};
